import { decamelizeString } from "./decamelizeString";

// Credits: https://github.com/sindresorhus/humanize-string/blob/main/index.js
export default function humanizeString(input: string): string {
  let output = decamelizeString(input)
    .replace(/[_-]+/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();

  output = output.charAt(0).toUpperCase() + output.slice(1);

  return output;
}
